import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import { baseTheme } from '../../theme';
import FileDropZone from './drop-zone';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      width: '25%',
      backgroundColor: theme.palette.background.paper,
      margin: '15vh auto',
      borderRadius: '10px',
    },
    image: {
      width: '90%',
      display: 'block',
      margin: '0 auto',
      borderRadius: '10px',
    },
  }),
);

interface IPhotoUploaderProps {
  cancelUpload: () => void;
  uploadPhoto: (blogURL: string, fileName: string) => void;
  title: string;
}

export default function PhotoUploader(props: IPhotoUploaderProps) {
  const { cancelUpload, uploadPhoto, title } = props;
  const styles = useStyles(baseTheme);
  const [file, setFile] = useState<any | null>(null);

  const handleDropZoneCallBack = (files: any[]) => {
    setFile(files[0]);
  };

  const handleUpload = () => {
    uploadPhoto(file.blobUrl, file.name);
  };

  const isFileSelected = file?.blobUrl ? false : true;

  return (
    <div className={styles.root}>
      <h2>{title}</h2>

      {!file ?
        <FileDropZone handleDropFiles={handleDropZoneCallBack} />
        :
        <img src={file.blobUrl} alt="preview" className={styles.image} />
      }

      <Button onClick={handleUpload} disabled={isFileSelected}>upload</Button>
      <Button onClick={cancelUpload}>cancel</Button>
    </div>
  );
}
